// Blocklist of inappropriate, offensive, trademark, or problematic words
// These words should be filtered from the solution word list

export const OFFENSIVE_WORDS = [
  'BOOBS', 'HORNY', 'SLUTS', 'BITCH', 'WHORE', 'PENIS', 'PUSSY',
  'COCKS', 'DICKS', 'FUCKS', 'SHITS', 'DAMNS', 'HELLS', 'ASSES',
  'BONER', 'BALLS', 'TAINT', 'TWATS', 'CRACK', 'COCKS', 'PRICK',
  'TURDS', 'SHITE', 'CUMMY', 'HOOEY', 'DUNGS', 'POOPS', 'CRAPS',
  'SLUT', 'COCK', 'DICK', 'SHIT', 'DAMN', 'HELL', 'TURD', 'CRAP',
  'POOP', 'DUNG', 'JIGGS', 'JISMS', 'TITTY', 'TITIS'
];

export const TRADEMARK_WORDS = [
  'XEROX', 'APPLE', 'INTEL', 'CISCO', 'ADOBE', 'NOKIA', 'SONY',
  'FEDEX', 'PEPSI', 'ROLEX', 'GUCCI', 'PRADA', 'IKEA', 'TESLA',
  'MAZDA', 'HONDA', 'LEXUS', 'KODAK', 'KRAFT'
];

export const PROPER_NOUNS = [
  'JESUS', 'ALLAH', 'MOSES', 'PARIS', 'TOKYO', 'CHINA', 'INDIA',
  'JAMES', 'SMITH', 'JONES', 'DAVIS', 'BROWN', 'EGYPT', 'KOREA',
  'JAPAN', 'SYRIA', 'LIBYA', 'TEXAS', 'GHANA', 'SUDAN', 'YEMEN'
];

export const MEDICAL_ANATOMICAL = [
  'RECTA', 'ANALS', 'FECAL', 'FETAL', 'VULVA', 'TAINT'
];

export const BLOCKLIST = [
  ...OFFENSIVE_WORDS,
  ...TRADEMARK_WORDS,
  ...PROPER_NOUNS,
  ...MEDICAL_ANATOMICAL
];
